import * as THREE from "three";
import * as perlin from "./lib/perlin"
import sceneConfig from "./conf/config-prod.js"
// import { getSceneConfig } from "./conf/config"

// const sceneConfig = getSceneConfig()

import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import Stats from 'three/addons/libs/stats.module.js';
import { GUI } from 'three/addons/libs/lil-gui.module.min.js';
import { HorizontalBlurShader } from 'three/addons/shaders/HorizontalBlurShader.js';
import { VerticalBlurShader } from 'three/addons/shaders/VerticalBlurShader.js';

// let renderer
// let stats

let shadowGroup, renderTarget, renderTargetBlur, shadowCamera, cameraHelper, depthMaterial, horizontalBlurMaterial, verticalBlurMaterial;
let plane, blurPlane, fillPlane;
let camera,
  // scene, 
  renderer, stats, gui;

const meshes = [];

const PLANE_WIDTH = 5;
const PLANE_HEIGHT = 5;
const CAMERA_HEIGHT = 0.5;


const randomBetween = (min, max) => Math.random() * (max - min) + min;

const state = {
  shadow: {
    blur: sceneConfig?.shadow?.blur ?? randomBetween(0.01, 5),
    darkness: sceneConfig?.shadow?.darkness ?? randomBetween(1, 5),
    opacity: sceneConfig?.shadow?.opacity ?? Math.random(), // Assuming opacity is between 0 and 1
  },
  plane: {
    color: '#ffffff',
    // color: sceneConfig?.plane?.color ?? `#${Math.floor(Math.random()*16777215).toString(16)}`, // Random hex color
    opacity: sceneConfig?.plane?.opacity ?? Math.random(), // Assuming opacity is between 0 and 1
  },
  showWireframe: false,
  sphere: {
    radius: sceneConfig?.sphere?.radius ?? randomBetween(0.01, 1),
    widthSegments: 128, // You might want to randomize this as well
    heightSegments: 128, // You might want to randomize this as well
  }
};



var scene = new THREE.Scene();
// var camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.1, 1000);

// camera.position.z = 5;

// var ambientLight2 = new THREE.AmbientLight( 0xffffff, 1 );
// scene.add( ambientLight2 );

// const spotLight = new THREE.SpotLight( 0xffffff );
// spotLight.position.set( 10, 10, 10 );
// scene.add( spotLight );



function init() {

  camera = new THREE.PerspectiveCamera(50, window.innerWidth / window.innerHeight, 0.1, 1000);
  // camera.position.set( 0.5, 1, 2 );
  camera.position.set(0.5, 1, 5);

  scene = new THREE.Scene();
  scene.background = new THREE.Color(0xffffff);

  if(sceneConfig.showGui) {
    stats = new Stats();
    document.body.appendChild(stats.dom);
  }

  window.addEventListener('resize', onWindowResize);

  // add the example meshes

  // const geometries = [
  //   new THREE.BoxGeometry( 0.4, 0.4, 0.4 ),
  //   new THREE.IcosahedronGeometry( 0.3 ),
  //   new THREE.TorusKnotGeometry( 0.4, 0.05, 256, 24, 1, 3 )
  // ];

  // const material = new THREE.MeshNormalMaterial();

  // for ( let i = 0, l = geometries.length; i < l; i ++ ) {

  //   const angle = ( i / l ) * Math.PI * 2;

  //   const geometry = geometries[ i ];
  //   const mesh = new THREE.Mesh( geometry, material );
  //   mesh.position.y = 0.1;
  //   mesh.position.x = Math.cos( angle ) / 2.0;
  //   mesh.position.z = Math.sin( angle ) / 2.0;
  //   scene.add( mesh );
  //   meshes.push( mesh );

  // }

  sceneConfig.spheres.map(s => {
    s.sphere_geometry = new THREE.SphereGeometry(state.sphere.radius, 128, 128);
    // s.sphere_geometry = new THREE.SphereGeometry(1, 128, 128);
    const texture = new THREE.TextureLoader().load(s.matcapTextureImg);
    texture.format = THREE.RGBAFormat

    if (s.matcapTextureImg.includes('trans')) {
      s.material = new THREE.MeshStandardMaterial({
        map: texture,
        transparent: true,
        alphaTest: 0.5,
        side: THREE.FrontSide,
      });

    } else {
      s.material = new THREE.MeshMatcapMaterial({
        matcap: texture,
        transparent: true,
        alphaTest: 0.1,
        specular: 0xcccccc,
        side: THREE.FrontSide,
      });
    }
    s.sphere = new THREE.Mesh(s.sphere_geometry, s.material);
    s.sphere.geometry.attributes.position.needsUpdate = true;
    // s.sphere.position.x = 2
    // s.sphere.position.y = 0.3
    // s.sphere.position.z = 2
    scene.add(s.sphere)
    meshes.push(s.sphere)
  })





  // the container, if you need to move the plane just move this
  shadowGroup = new THREE.Group();
  shadowGroup.position.y = - 1.2;
  scene.add(shadowGroup);

  // the render target that will show the shadows in the plane texture
  renderTarget = new THREE.WebGLRenderTarget(1024, 1024);
  renderTarget.texture.generateMipmaps = false;

  // the render target that we will use to blur the first render target
  renderTargetBlur = new THREE.WebGLRenderTarget(1024, 1024);
  renderTargetBlur.texture.generateMipmaps = false;


  // make a plane and make it face up
  const planeGeometry = new THREE.PlaneGeometry(PLANE_WIDTH, PLANE_HEIGHT).rotateX(Math.PI / 2);
  const planeMaterial = new THREE.MeshBasicMaterial({
    map: renderTarget.texture,
    opacity: state.shadow.opacity,
    transparent: true,
    depthWrite: false,
  });
  plane = new THREE.Mesh(planeGeometry, planeMaterial);
  // make sure it's rendered after the fillPlane
  plane.renderOrder = 1;
  shadowGroup.add(plane);

  // the y from the texture is flipped!
  plane.scale.y = - 1;

  // the plane onto which to blur the texture
  blurPlane = new THREE.Mesh(planeGeometry);
  blurPlane.visible = false;
  shadowGroup.add(blurPlane);

  // the plane with the color of the ground
  const fillPlaneMaterial = new THREE.MeshBasicMaterial({
    color: state.plane.color,
    opacity: state.plane.opacity,
    transparent: true,
    depthWrite: false,
  });
  fillPlane = new THREE.Mesh(planeGeometry, fillPlaneMaterial);
  fillPlane.rotateX(Math.PI);
  shadowGroup.add(fillPlane);

  // the camera to render the depth material from
  shadowCamera = new THREE.OrthographicCamera(- PLANE_WIDTH / 2, PLANE_WIDTH / 2, PLANE_HEIGHT / 2, - PLANE_HEIGHT / 2, 0, CAMERA_HEIGHT);
  shadowCamera.rotation.x = Math.PI / 2; // get the camera to look up
  shadowGroup.add(shadowCamera);

  cameraHelper = new THREE.CameraHelper(shadowCamera);

  // like MeshDepthMaterial, but goes from black to transparent
  depthMaterial = new THREE.MeshDepthMaterial();
  depthMaterial.userData.darkness = { value: state.shadow.darkness };
  depthMaterial.onBeforeCompile = function (shader) {

    shader.uniforms.darkness = depthMaterial.userData.darkness;
    shader.fragmentShader = /* glsl */`
      uniform float darkness;
      ${shader.fragmentShader.replace(
      'gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );',
      'gl_FragColor = vec4( vec3( 0.0 ), ( 1.0 - fragCoordZ ) * darkness );'
    )}
    `;

  };

  depthMaterial.depthTest = false;
  depthMaterial.depthWrite = false;

  horizontalBlurMaterial = new THREE.ShaderMaterial(HorizontalBlurShader);
  horizontalBlurMaterial.depthTest = false;

  verticalBlurMaterial = new THREE.ShaderMaterial(VerticalBlurShader);
  verticalBlurMaterial.depthTest = false;

  //

  if (sceneConfig.showGui) {



    gui = new GUI();
    const shadowFolder = gui.addFolder('shadow');
    shadowFolder.open();
    const planeFolder = gui.addFolder('plane');
    planeFolder.open();
    const sphereFolder = gui.addFolder('sphere');
    sphereFolder.open();


    // shadowFolder.add( state.shadow, 'blur', 0, 15, 0.1 );
    shadowFolder.add(state.shadow, 'blur', 0, 30, 0.1);
    // shadowFolder.add( state.shadow, 'darkness', 1, 5, 0.1 ).onChange( function () {
    shadowFolder.add(state.shadow, 'darkness', 1, 10, 0.1).onChange(function () {

      depthMaterial.userData.darkness.value = state.shadow.darkness;

    });
    shadowFolder.add(state.shadow, 'opacity', 0, 1, 0.01).onChange(function () {

      plane.material.opacity = state.shadow.opacity;

    });
    planeFolder.addColor(state.plane, 'color').onChange(function () {

      fillPlane.material.color = new THREE.Color(state.plane.color);

    });
    planeFolder.add(state.plane, 'opacity', 0, 1, 0.01).onChange(function () {

      fillPlane.material.opacity = state.plane.opacity;

    });
    sphereFolder.add(state.sphere, 'radius', 0.01, 1, 0.01).onChange(function (newRadius) {
      // Mettez à jour la géométrie de chaque sphère dans sceneConfig.spheres
      sceneConfig.spheres.forEach(s => {
        // Supprimez l'ancienne géométrie
        s.sphere.geometry.dispose();
        // Créez une nouvelle géométrie avec le nouveau rayon
        s.sphere.geometry = new THREE.SphereGeometry(newRadius, state.sphere.widthSegments, state.sphere.heightSegments);
      });
    });

    gui.add(state, 'showWireframe', true).onChange(function () {

      if (state.showWireframe) {

        scene.add(cameraHelper);

      } else {

        scene.remove(cameraHelper);

      }

    });
  }

  //

  renderer = new THREE.WebGLRenderer({ antialias: true });
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setSize(window.innerWidth, window.innerHeight);
  document.body.appendChild(renderer.domElement);

  //

  new OrbitControls(camera, renderer.domElement);

}

function onWindowResize() {

  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();

  renderer.setSize(window.innerWidth, window.innerHeight);

}

// renderTarget --> blurPlane (horizontalBlur) --> renderTargetBlur --> blurPlane (verticalBlur) --> renderTarget
function blurShadow(amount) {

  blurPlane.visible = true;

  // blur horizontally and draw in the renderTargetBlur
  blurPlane.material = horizontalBlurMaterial;
  blurPlane.material.uniforms.tDiffuse.value = renderTarget.texture;
  horizontalBlurMaterial.uniforms.h.value = amount * 1 / 256;

  renderer.setRenderTarget(renderTargetBlur);
  renderer.render(blurPlane, shadowCamera);

  // blur vertically and draw in the main renderTarget
  blurPlane.material = verticalBlurMaterial;
  blurPlane.material.uniforms.tDiffuse.value = renderTargetBlur.texture;
  verticalBlurMaterial.uniforms.v.value = amount * 1 / 256;

  renderer.setRenderTarget(renderTarget);
  renderer.render(blurPlane, shadowCamera);

  blurPlane.visible = false;

}

var update = function ({ sphere, speed, k, mul }) {
  var time = performance.now() * speed;
  var p = new THREE.Vector3();
  const positions = sphere.geometry.attributes.position;

  for (var i = 0; i < positions.count; i++) {
    p.fromBufferAttribute(positions, i)
    p.normalize().multiplyScalar(
      state.sphere.radius * (1 + mul * noise.perlin3(p.x * k + time, p.y * k, p.z * k))
    )
    positions.setXYZ(i, p.x, p.y, p.z);
  }

  positions.needsUpdate = true;
  sphere.geometry.computeVertexNormals();
};


function animate() {
  requestAnimationFrame(animate);

  sceneConfig.spheres.map(s => update({
    k: s.perlin.k,
    mul: s.perlin.mul,
    speed: s.perlin.speed,
    sphere: s.sphere,
  }))
  renderer.render(scene, camera);

  // meshes.forEach( mesh => {
  //   mesh.rotation.x += 0.001;
  //   mesh.rotation.y += 0.002;
  // } );



  // remove the background
  const initialBackground = scene.background;
  scene.background = null;

  // force the depthMaterial to everything
  cameraHelper.visible = false;
  scene.overrideMaterial = depthMaterial;

  // set renderer clear alpha
  const initialClearAlpha = renderer.getClearAlpha();
  renderer.setClearAlpha(0);

  // render to the render target to get the depths
  renderer.setRenderTarget(renderTarget);
  renderer.render(scene, shadowCamera);

  // and reset the override material
  scene.overrideMaterial = null;
  cameraHelper.visible = true;

  blurShadow(state.shadow.blur);

  // a second pass to reduce the artifacts
  // (0.4 is the minimum blur amout so that the artifacts are gone)
  blurShadow(state.shadow.blur * 0.4);

  // reset and render the normal scene
  renderer.setRenderTarget(null);
  renderer.setClearAlpha(initialClearAlpha);
  scene.background = initialBackground;

  renderer.render(scene, camera);
  if(sceneConfig.showGui) {
    stats.update();
  }
}

const resize = () => {
  renderer.setSize(window.innerWidth, window.innerHeight)
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
};

export const createScene = (el) => {
  init()

  renderer = new THREE.WebGLRenderer({ antialias: true, canvas: el });
  renderer.setClearColor(0xfafafa);
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setSize(window.innerWidth, window.innerHeight);
  resize();
  animate();
}

window.addEventListener('resize', resize);

export {
  animate,
  renderer,
}
